import { Link, useLocation } from "react-router-dom";
import {
    BiBriefcase,
    BiInfoCircle,
    BiPhoneCall,
    BiUniversalAccess,
    BiBuildings,
} from "react-icons/bi";

const navitems = [
    {
        text: "Für wen?",
        url: "#fur-wen",
        hash: true,
        icon: <BiUniversalAccess className="md:hidden" />,
    },
    {
        text: "Über mich",
        url: "#uber-mich",
        hash: true,
        icon: <BiInfoCircle className="md:hidden" />,
    },
    {
        text: "Dienstleistungen",
        url: "#dienstleistungen",
        hash: true,
        icon: <BiBriefcase className="md:hidden" />,
    },
    {
        text: "Kooperationen",
        url: "/kooperationen",
        hash: false,
        icon: <BiBuildings className="md:hidden" />,
    },
];

const Navbar = ({ contact = true }: { contact?: boolean }) => {
    const location = useLocation();
    const isHomePage = location.pathname === "/";

    return (
        <nav className="flex border-[1px] border-text/20 gap-2 text-base text-text items-center fixed bottom-3 md:bottom-0 left-1/2 -translate-x-1/2 md:translate-x-0 md:left-0 md:relative bg-bg rounded-full p-1">
            {navitems.map((e, i) => {
                // If on home page and it's a hash link, use anchor tag
                // If it's the Kooperationen link or we're not on home page, use Link
                if (isHomePage && e.hash) {
                    return (
                        <a
                            className="text-lg md:text-base whitespace-nowrap px-4 py-2 rounded-full border hover:border-text border-transparent transition-all"
                            href={e.url}
                            key={i}
                        >
                            <span className="absolute opacity-0 pointer-events-none md:relative md:opacity-100 md:pointer-events-auto">
                                {e.text}
                            </span>{" "}
                            {e.icon}
                        </a>
                    );
                } else if (!e.hash) {
                    return (
                        <Link
                            className="text-lg md:text-base whitespace-nowrap px-4 py-2 rounded-full border hover:border-text border-transparent transition-all"
                            to={e.url}
                            key={i}
                        >
                            <span className="absolute opacity-0 pointer-events-none md:relative md:opacity-100 md:pointer-events-auto">
                                {e.text}
                            </span>{" "}
                            {e.icon}
                        </Link>
                    );
                } else {
                    // Not on home page and it's a hash link, go home first
                    return (
                        <Link
                            className="text-lg md:text-base whitespace-nowrap px-4 py-2 rounded-full border hover:border-text border-transparent transition-all"
                            to={`/${e.url}`}
                            key={i}
                        >
                            <span className="absolute opacity-0 pointer-events-none md:relative md:opacity-100 md:pointer-events-auto">
                                {e.text}
                            </span>{" "}
                            {e.icon}
                        </Link>
                    );
                }
            })}
            {contact &&
                (isHomePage ? (
                    <a
                        href="#kontakt"
                        className="text-lg md:text-base px-4 py-2 border border-text/20 rounded-full hover:border-text bg-text/5 transition-all"
                    >
                        <span className="absolute opacity-0 pointer-events-none md:relative md:opacity-100 md:pointer-events-auto">
                            Kontakt
                        </span>{" "}
                        <BiPhoneCall className="md:hidden" />
                    </a>
                ) : (
                    <Link
                        to="/#kontakt"
                        className="text-lg md:text-base px-4 py-2 border border-text/20 rounded-full hover:border-text transition-all"
                    >
                        <span className="absolute opacity-0 pointer-events-none md:relative md:opacity-100 md:pointer-events-auto">
                            Kontakt
                        </span>{" "}
                        <BiPhoneCall className="md:hidden" />
                    </Link>
                ))}
        </nav>
    );
};

export default Navbar;
